import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFeeDiscountRewards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M7.975 11.55c-.435 0-.806-.154-1.113-.461A1.518 1.518 0 0 1 6.4 9.975c0-.435.154-.806.462-1.114A1.518 1.518 0 0 1 7.975 8.4c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.518 1.518 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.113-.461a1.518 1.518 0 0 1-.462-1.114c0-.435.154-.806.462-1.114a1.518 1.518 0 0 1 1.113-.461c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63 6.57-6.57.63.63-6.57 6.57ZM20.25.75l.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M10 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM1.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19.671 8.459a.75.75 0 0 1 1.06.022 7.253 7.253 0 0 1-3.56 12.075.75.75 0 0 1-.343-1.46 5.753 5.753 0 0 0 2.821-9.577.75.75 0 0 1 .022-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorFeeDiscountRewards;
